export default __webpack_public_path__ + "static/media/imagen_business.e16c0739.png";